import request from '@/utils/request'

export function getAcceptOrderBillList(data) {
  return request({
    url: '/api/completionOfDelivery/acceptOrderBillList',
    method: 'post',
    data,
  })
}
export function getAcceptOrderDetailList(data) {
  return request({
    url: '/api/completionOfDelivery/acceptOrderDetailList',
    method: 'post',
    data,
  })
}
export function getAcceptOrderBase(query) {
  return request({
    url: '/api/completionOfDelivery/acceptOrderBase',
    method: 'get',
    query,
  })
}
